<div class="pt-100">
    <div class="title-breadcumbs mb-0">
        <div class="container">
            <div class="entry-header">
                <h2 class="entry-title">{{'label-title.contact-us' | translate}}</h2>
            </div>
            <div class="breadcrumb-container">
                <div class="breadcrumbs"><a href="javascript:;">{{"label-title.home" | translate}}</a><span
                        class="separator">&gt;</span><span>{{'label-title.contact-us' | translate}}</span></div>
            </div>
        </div>
    </div>
</div>

<section class="contact-section">
    <!-- <iframe
        src="https://www.google.com/maps/place/KB+Imitation/@22.3011586,70.8156483,19z/data=!3m1!4b1!4m6!3m5!1s0x3959b50b1c0728d9:0x37577b6bef5df65c!8m2!3d22.3011574!4d70.816292!16s%2Fg%2F11xgk_kxg3?entry=ttu&g_ep=EgoyMDI1MDUyOC4wIKXMDSoASAFQAw%3D%3D"
        class="iframediv" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->


        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d922.8470170963517!2d70.81564826962689!3d22.3011586395234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959b50b1c0728d9%3A0x37577b6bef5df65c!2sKB%20Imitation!5e0!3m2!1sen!2sin!4v1748780377200!5m2!1sen!2sin"class="iframediv" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="container">
        <div class="row mt-5">
            <div class="col-12">
                <h2 class="contact-title"> {{'label-title.lets-connect' | translate}} </h2>
            </div>
            <div class="col-lg-8">
                <form [formGroup]="contactForm">
                    <div class="row form-contact contact_form">
                        <div class="col-12">
                            <div class="form-group">
                                <textarea class="form-control w-100 hide-on-focus" formControlName="message"
                                    id="message" cols="30" rows="9"
                                    placeholder="{{'label-title.message' | translate}}"></textarea>
                                <div class="invalid-feedback d-block"
                                    *ngIf="contactForm.get('message')?.errors?.['required'] && contactForm.get('message')?.touched">
                                    {{ "label-title.message" | translate }} {{ "label-title.is-required" | translate }}.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <input class="form-control hide-on-focus" formControlName="firstName" id="firstName"
                                    type="text" placeholder="{{'label-title.first-name' | translate}}">
                                <div class="invalid-feedback d-block"
                                    *ngIf="contactForm.get('firstName')?.errors?.['required'] && contactForm.get('firstName')?.touched">
                                    {{ "label-title.first-name" | translate }} {{ "label-title.is-required" | translate
                                    }}.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <input class="form-control hide-on-focus" formControlName="lastName" id="lastName"
                                    type="text" placeholder="{{'label-title.last-name' | translate}}">
                                <div class="invalid-feedback d-block"
                                    *ngIf="contactForm.get('lastName')?.errors?.['required'] && contactForm.get('lastName')?.touched">
                                    {{ "label-title.last-name" | translate }} {{ "label-title.is-required" | translate
                                    }}.
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <input class="form-control hide-on-focus" formControlName="email" id="email"
                                    type="email" placeholder="{{'label-title.email' | translate}}">
                                <div class="invalid-feedback d-block"
                                    *ngIf="contactForm.get('email')?.errors?.['required'] && contactForm.get('email')?.touched">
                                    {{'validation-title.email-is-required' | translate}}.</div>
                                <div class="invalid-feedback d-block"
                                    *ngIf="contactForm.get('email')?.errors?.['pattern'] && contactForm.get('email')?.touched">
                                    {{'validation-title.email-is-invalid' | translate}}.</div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-group mt-3">
                    <button type="button" class="button button-contactForm"
                        (click)="onSubmit()">{{'button-title.send-message' |
                        translate}} </button>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="d-flex contact-info">
                    <span class="contact-info__icon"><i class="ti-home"></i></span>
                    <div class="media-body">
                        <h3><a href="javascript:;">{{ companyAddress }}</a></h3>
                        <p>{{'label-title.address-us' | translate}}</p>
                    </div>
                </div>
                @for (contact of companyContacts; track $index) {
                  <div class="d-flex contact-info">
                      <span class="contact-info__icon"><i class="ti-tablet"></i></span>
                      <div class="media-body">
                          <h3><a class="d-inline-block" [href]="'tel:' + contact.phone">
                                {{ contact.name }} - {{ helper.countryPhoneCode }} {{ contact.phone }}
                              </a></h3>
                          <p>{{'label-title.call-us' | translate}}</p>
                      </div>
                  </div>
                }
                <div class="d-flex contact-info">
                    <span class="contact-info__icon"><i class="ti-email"></i></span>
                    <div class="media-body">
                        <h3><a class="d-inline-block" [href]="'mailto:' + companyEmail">
                                {{ companyEmail }}
                            </a></h3>
                        <p>{{'label-title.email-us' | translate}} </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
